import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { CurrencyPipe } from '@angular/common';
import { LoadingBoxComponent } from '../../../../../shared/components/loading-box/loading-box.component';
import { ProdutoService } from '../../../../../shared/services/apis/produto/produto.service';
import { ProdutoListaRequest } from '../../../../../shared/services/requests/produto/produto-lista.request';
import { ProdutoImpressaoStruct } from '../../../../../shared/services/structs/produto/produto-impressao.struct';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';

export interface ImpressaoProdutoListaSimplesData {
    filtros: ProdutoListaRequest;
}

@Component({
    selector: 'app-impressao-produto-lista-simples',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        LoadingBoxComponent
    ],
    templateUrl: './impressao-produto-lista-simples.component.html',
    styleUrls: ['./impressao-produto-lista-simples.component.css']
})
export class ImpressaoProdutoListaSimplesComponent implements OnInit {

    public isLoading: boolean = false;
    public relatorioProdutos: ProdutoImpressaoStruct[] = [];
    public displayedColumns: string[] = ['codigoSku', 'descricao', 'unidade', 'precoVenda', 'precoCusto'];

    constructor(
        public dialogRef: MatDialogRef<ImpressaoProdutoListaSimplesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImpressaoProdutoListaSimplesData,
        private produtoService: ProdutoService,
        private alertService: AlertService
    ) { }

    ngOnInit(): void {
        this.buscarRelatorioProdutos();
    }

    private buscarRelatorioProdutos(): void {
        this.isLoading = true;
        const request = new ProdutoListaRequest();
        Object.assign(request, this.data.filtros);

        this.produtoService.getPrint(request).subscribe({
            next: (res) => {
                this.isLoading = false;
                if (!res.isError) {
                    this.relatorioProdutos = res.list || [];
                } else {
                    this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    this.fechar();
                }
            },
            error: (err) => {
                this.isLoading = false;
                this.alertService.show('Erro', 'Erro ao gerar relatório de produtos', AlertType.error);
                this.fechar();
            }
        });
    }

    public imprimir(): void {
        const conteudoParaImprimir = document.querySelector('.modal-print-container');

        if (conteudoParaImprimir) {
            const janelaImpressao = window.open('', '', 'height=600,width=800');

            if (janelaImpressao) {
                const styles = Array.from(document.styleSheets)
                    .map(styleSheet => {
                        try {
                            return Array.from(styleSheet.cssRules)
                                .map(rule => rule.cssText)
                                .join('');
                        } catch (e) {
                            return '';
                        }
                    })
                    .join('');

                janelaImpressao.document.write(`
          <html>
            <head>
              <title>Imprimir Lista de Produtos</title>
              <base href="/">
              <style>
                ${styles}
                /* Print Specific Overrides */
                html, body {
                    height: auto !important;
                    min-height: 0 !important;
                    overflow: visible !important;
                    margin: 20px;
                    font-family: Roboto, "Helvetica Neue", sans-serif;
                    color: #000;
                    background: #fff;
                }
                .no-print { display: none !important; }
                .modal-print-container {
                    display: block !important;
                    width: 100% !important;
                    height: auto !important;
                    min-height: 0 !important;
                    overflow: visible !important;
                    box-shadow: none !important;
                    margin: 0 !important;
                    padding: 0 !important;
                }
                
                /* Force MatTable styles for print if needed */
                .mat-mdc-table { background: white !important; }
                .mat-mdc-header-cell { color: black !important; font-weight: bold !important; border-bottom: 2px solid black !important; }
                .mat-mdc-cell { color: black !important; border-bottom: 1px solid #ddd !important; }
                
                .title-header { text-align: center; margin-bottom: 20px; }
                h2 { font-size: 16px; margin: 0; }
              </style>
            </head>
            <body>
              ${conteudoParaImprimir.innerHTML}
            </body>
          </html>
        `);

                janelaImpressao.document.close();
                janelaImpressao.focus();

                setTimeout(() => {
                    janelaImpressao.print();
                    janelaImpressao.close();
                }, 800);
            }
        }
    }

    public fechar(): void {
        this.dialogRef.close();
    }
}
